
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 4 4"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"1","cy":"1","r":".8","fill":"#92B8B8"}})])
          )
        }
      }
    